import api from './api';
import createTracker, { RESET } from '../middleware/rollbar';
import {
  AUTHENTICATION_INVALIDATE,
  AUTHENTICATION_SUCCESS
} from '../../actions/api/auth';
import { identify } from '../../selectors/debugging';

export function relay(dispatch, state, action) {
  const { type } = action;
  switch (type) {
    case AUTHENTICATION_INVALIDATE:
      return dispatch({ type: RESET });
    case api.INITIALIZE:
    case AUTHENTICATION_SUCCESS:
      dispatch(identify(state));

    default:
  }
}

const tracker = createTracker(relay);

export default tracker;



// WEBPACK FOOTER //
// ./js/store/config/debugging.js